/* eslint camelcase: 0 */
import RichTextSerializer from '@components/RichTextSerializer'

type ListCardsProps = {
	slice: any
}

export default function ListCards({ slice }: ListCardsProps) {
	const { primary, items } = slice || {}
	const { section_title, section_description } = primary || {}

	return (
		<section className="section">
			<div className="container">
				<div className="space-y-6 md:space-y-10">
					{/* Section title */}
					{section_title?.[0]?.text && (
						<h2 className="text-2xl font-medium title md:text-4xl md:text-center">
							{section_title[0].text}
						</h2>
					)}

					{/* Section description */}
					{section_description?.[0] && (
						<div className="space-y-6 md:space-y-10 md:text-center">
							<RichTextSerializer content={section_description} />
						</div>
					)}
				</div>

				{/* Cards */}
				{Array.isArray(items) && items.length > 0 && (
					<div className="grid items-start md:grid-cols-2 gap-y-10 md:gap-y-12 md:gap-x-12 mt-14 md:mt-20">
						{items.map(({ card_title, card_description, bullet_list }, i) => (
							<div
								className="px-10 pt-10 border border-gray-200 rounded-sm pb-14 shadow-bbx md:shadow-bbx-lg"
								// eslint-disable-next-line react/no-array-index-key
								key={i}
							>
								{/* Card title */}
								{card_title?.[0]?.text && (
									<h3 className="text-2xl title md:text-3xl">{card_title[0].text}</h3>
								)}

								{/* Card description */}
								{card_description?.[0]?.text && (
									<p className="mt-4 font-medium text-gray-500 md:text-lg">
										{card_description[0].text}
									</p>
								)}

								{/* Bullet list */}
								{Array.isArray(bullet_list) && (
									<ul className="mt-10 space-y-6">
										{bullet_list.map(({ text }, index) =>
											text ? (
												// eslint-disable-next-line react/no-array-index-key
												<li className="flex font-light gap-x-3" key={index}>
													{/* Checkmark bullet point */}
													<svg
														width="16"
														height="16"
														viewBox="0 0 16 16"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
														className="shrink-0 mt-0.5"
														aria-hidden="true"
													>
														<rect width="16" height="16" rx="8" fill="#F98979" />
														<path
															d="M5 8.25L7.52632 10.5L11 6"
															stroke="white"
															strokeWidth="1.5"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
													</svg>

													{text}
												</li>
											) : null
										)}
									</ul>
								)}
							</div>
						))}
					</div>
				)}
			</div>
		</section>
	)
}
